import { useEffect, useState } from 'react'
import BaseHeadline from '../../../components/general/BaseHeadline'
import { THeading } from '../../../types/index'
import { API } from '../../../api/api'
import Marquee from 'react-fast-marquee'
import BaseGhostButton from '../../../components/general/BaseGhostButton'

type imageType = {
    name: string
    url: string
}

type CustomersType = {
    heading?: THeading
    logos: {
        data: {
            attributes: imageType
        }[]
    }
}

export default function Customers(props: CustomersType) {
    const [logos, setLogos] = useState<imageType[]>([])
    useEffect(() => {
        setLogos(props.logos?.data?.map((item) => item.attributes) as imageType[])
    }, [props.logos])

    const thirdLength = Math.floor(logos.length / 3)

    const firstQuarter = props.logos.data.slice(0, thirdLength)
    const secondQuarter = props.logos.data.slice(thirdLength, thirdLength * 2)
    const thirdQuarter = props.logos.data.slice(thirdLength * 2)
    return (
        <section className="py-20 px-4 w-full sm:px-8 xl:px-32">
            <div className="w-full grid grid-cols-1 lg:grid-cols-12 gap-24">
                <div className='col-span-1 lg:col-span-4 my-auto'>
                    <BaseHeadline
                        headline={props.heading?.headline ?? "test"}
                        text={props.heading?.text ?? ""}
                        width='w-fit'
                    />
                    {/* <BaseText 
                    text='Ihr logo soll hier auch hin?'
                    textColor='opacity-100 text-white font-semibold text-lg mt-4'
                    classProps='-mb-2'
                    /> */}
                    <BaseGhostButton 
                    text={'Ihr Logo hier?'} 
                    url={'/contact#_'} 
                    classProps='text-lg mt-4'                   
                    />
                </div>
                <div className='col-span-1 lg:col-span-8 flex flex-col  w-full justify-center items-center gap-8 z-0"'>
                    <Marquee speed={25} gradient gradientColor="#141312" gradientWidth={150} pauseOnHover={false} direction={"left"}>
                        {firstQuarter.map((logo, index) => (
                            <img
                                key={index}
                                src={API.img + logo.attributes.url}
                                alt={logo.attributes.name}
                                className="w-32 md:w-48 object-contain mix-blend-color-burn aspect-[3/2] -z-10 mx-12 grayscale "
                            />
                        ))}
                    </Marquee>
                    <Marquee speed={25} gradient gradientColor="#141312" gradientWidth={150} pauseOnHover={false} direction={"right"}>
                        {secondQuarter.map((logo, index) => (
                            <img
                                key={index}
                                src={API.img + logo.attributes.url}
                                alt={logo.attributes.name}
                                className="w-32 md:w-48 object-contain mix-blend-color-burn aspect-[3/2] -z-10 mx-12 grayscale "
                            />
                        ))}
                    </Marquee>
                    <Marquee speed={25} gradient gradientColor="#141312" gradientWidth={150} pauseOnHover={false} direction={"left"}>
                        {thirdQuarter.map((logo, index) => (
                            <img
                                key={index}
                                src={API.img + logo.attributes.url}
                                alt={logo.attributes.name}
                                className="w-32 md:w-48 object-contain mix-blend-color-burn aspect-[3/2] -z-10 mx-12 grayscale "
                            />
                        ))}
                    </Marquee>

                </div>
            </div>
        </section>
    )
}
